import { useState } from "react";
import { Phone, Menu, X, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const LINKS = [
  ["Services", "#services"],
  ["Projects", "#projects"],
  ["Process", "#process"],
  ["About", "#about"],
  ["Contact", "#contact"],
];

export default function Navbar({ content }) {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-storm/85 backdrop-blur-xl border-b border-gold/15" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 shrink-0" data-testid="nav-logo-link">
          <img src="/logo.png" alt="DRC502 Construction LLC" className="h-9 sm:h-12 w-auto object-contain" data-testid="nav-logo" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-link-${label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-gold transition-colors">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={`tel:${content.phone_tel}`} data-testid="nav-call-button"
            className="hidden sm:inline-flex items-center gap-2 bg-gold text-storm font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-gold-light transition-colors">
            <Phone size={15} strokeWidth={2.5} />
            {content.phone_display}
          </a>
          <Link to="/admin" data-testid="nav-admin-link" aria-label="Admin portal"
            className="p-2 rounded-full text-slate-500 hover:text-gold hover:bg-storm-700 transition-colors">
            <Lock size={16} />
          </Link>
          <button className="lg:hidden p-2 text-slate-300" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-gold/10 bg-storm/95 backdrop-blur-xl px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${label.toLowerCase()}`}
              className="font-mono text-sm uppercase tracking-[0.2em] text-slate-300 hover:text-gold transition-colors">
              {label}
            </a>
          ))}
          <a href={`tel:${content.phone_tel}`} data-testid="nav-mobile-call-button"
            className="inline-flex items-center gap-2 text-gold font-semibold">
            <Phone size={15} /> {content.phone_display}
          </a>
        </nav>
      )}
    </header>
  );
}
